import React from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import ProfileTextField from "./components/ProfileTextField";
// import ProfileSelectField from "./components/ProfileSelectField";

import request from "../../../utilities/requests";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NewUserDialog = ({ open, close, orgId, refresh }) => {
  const [username, setUsername] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [error, setError] = React.useState(null);

  const handleSave = async () => {
    let error;
    if (!username) {
      error = "Please enter a username";
    } else if (username.length < 10) {
      error = "Username must be at least 10 characters long";
    } else if (!email) {
      error = "Please enter an email";
    } else if (!phone) {
      error = "Please enter a phone number";
    } else if (!firstName) {
      error = "Please enter a first name";
    } else if (!lastName) {
      error = "Please enter a last name";
    }
    if (error) {
      setError(error);
      return;
    } else {
      setError(null);
    }

    const body = {
      username,
      email,
      phone,
      firstName,
      lastName,
      orgId
    }

    const result = await request("users/createadmin", "post", body);
    if (!result.success) {
      setError(result.error);
      return;
    }
    refresh();
    close();

  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={close}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              New Admin User
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container direction="column" spacing={3} style={{ padding: 20 }}>
          {error ? (
            <Grid item>
              <Alert severity="error">{error}</Alert>
            </Grid>
          ) : (
            <></>
          )}

          <Grid item>
            <TextField
              fullWidth
              label="username*"
              value={username}
              onChange={(e) => setUsername(e.target.value.toLowerCase())}
            />
            <Typography variant="caption">Please use the format 'FirstName.LastName' (e.g. tommy.lee)</Typography>
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="email*"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="phone*"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="first name*"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="last name*"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              onClick={handleSave}
              style={{ width: "100%" }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default NewUserDialog;
